import { Modal } from "react-bootstrap";

export default function ModalNetworkConfigPreview({ show, data, onClose }) {
  const renderData = () => {
    if (!data) return <p className="text-muted">Tidak ada data.</p>;
    if (typeof data === "string") {
      return (
        <pre className="bg-light p-3 rounded" style={{ whiteSpace: "pre-wrap" }}>
          {data}
        </pre>
      );
    }
    if (typeof data === "object") {
      return (
        <div className="table-responsive">
          <table className="table table-bordered table-sm">
            <tbody>
              <tr>
                <td className="font-weight-bold" style={{ width: "35%" }}>
                  VLAN
                </td>
                <td>{data.vlan || "-"}</td>
              </tr>
              <tr>
                <td className="font-weight-bold">VLAN Profile</td>
                <td>{data.vlan_profile || "-"}</td>
              </tr>
              <tr>
                <td className="font-weight-bold">Framed Pool</td>
                <td>{data.framed_pool || "-"}</td>
              </tr>
              <tr>
                <td className="font-weight-bold">OLT</td>
                <td>
                  {data.olt ? `${data.olt.name} (${data.olt.brand} ${data.olt.type})` : "-"}
                </td>
              </tr>
              <tr>
                <td className="font-weight-bold">PPPoE Username</td>
                <td>{data.pppoe_username || "-"}</td>
              </tr>
              <tr>
                <td className="font-weight-bold">PPPoE Password</td>
                <td>{data.pppoe_password || "-"}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
    return <p>{String(data)}</p>;
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Preview Network Config</Modal.Title>
      </Modal.Header>
      <Modal.Body>{renderData()}</Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Tutup
        </button>
      </Modal.Footer>
    </Modal>
  );
}
